export const LORE_ICONS = ["🐦‍🔥", "🥾", "🚪", "🗝️", "📦", "🥄", "🧾"];
export const APP_RANDOM_ICON = () =>
	LORE_ICONS[Math.floor(Math.random() * LORE_ICONS.length)];
